<template>
  <!-- style="overflow-y: auto;position: absolute;left: 0;right: 0;top: 0;bottom: 0;" -->
  <div>
    <!-- 头部 -->
    <div class="header">
      <header-tag :title="'开通会员'"></header-tag>
    </div>
    <!-- 表单部分 -->
    <div class="body">
      <div class="form-body">
        <div class="form-left">
          <p>通行证账号:</p>
          <p>会员类型:</p>
          <p>会员状态:</p>
          <p>到期时间:</p>
        </div>
        <div class="form-right">
          <p v-text="$store.state.user.userInfo.passportName"></p>
          <p v-text="vipType"></p>
          <p v-show="$store.state.user.userInfo.vipStatus>0">
            <span v-text='$store.state.user.userInfo.vipStatus'></span>天后到期
          </p>
          <p v-show="$store.state.user.userInfo.vipStatus==-1||$store.state.user.userInfo.vipStatus==0">未开通</p>
          <p v-show="!$store.state.user.userInfo.expireDate||$store.state.user.userInfo.vipStatus==0">未开通</p>
          <p v-show="$store.state.user.userInfo.expireDate&&$store.state.user.userInfo.vipStatus>0">
            <span v-text='$store.state.user.userInfo.expireDate'></span>到期
          </p>
        </div>
      </div>
      <div
        class="form-body"
        style="border-top: 2px dashed rgb(230, 230, 230);"
      >
        <div class="form-left">
          <p style='height:122px;line-height:normal;'>方案:</p>
          <p style='margin-bottom:20px;height:30px;line-height:30px;'>时长:</p>
          <p style='height:30px;line-height:30px;'>支付方式:</p>
        </div>
        <div class="form-right">
          <p class='Program'>
          <ul>
            <li
              @click='styleActive(0)'
              :class="{'active':!active}"
            >
              <div class='type'>VIP</div>
              <div class='price'>399元/年</div>
              <div class='sub'>约1.09元/天</div>
            </li>
            <li
              @click='styleActive(1)'
              :class="{'active':active}"
            >
              <div class='type'>SVIP</div>
              <div class='price'>1299元/年</div>
              <div class='sub'>约3.56元/天</div>
            </li>
            <li class='crown'>
              <a
                href="/memberPricing.html"
                target="_blank"
              >
                <img
                  src="@/assets/img/icon/crown.png"
                  alt=""
                >
                <span style='border-bottom:1px solid tomato;'>特权对比</span>
              </a>
            </li>
          </ul>
          </p>
          <p class='duration'>
            <button @click='cutBack'>-</button>
            <button
              v-text="duration"
              class='num'
            ></button>
            <button @click='add'>+</button>
            &nbsp;年
          </p>
          <p class='pay'>
          <ul>
            <li
              @click='payActive(0)'
              :class="{'active':!payac}"
            >
              <img
                src="@/assets/img/icon/u393.png"
                alt=""
              >
              支付宝
            </li>
            <li
              @click='payActive(1)'
              :class="{'active':payac}"
            >
              <img
                src="@/assets/img/icon/u392.svg"
                alt=""
              >
              微信
            </li>
          </ul>
          </p>
        </div>
      </div>
      <div
        class="form-body"
        style="border-top: 2px dashed rgb(230, 230, 230);"
      >
        <div class="form-left">
          <p>购买后到期时间:</p>
          <p>应付金额:</p>
        </div>
        <div class="form-right">
          <p
            class='buyExpireDate'
            v-text='buyExpireDate'
          ></p>
          <p class='money'>
            <span v-text='price'></span> 元
            <span
              v-show='$store.state.user.userInfo.judgeVip==2&&active==1'
              style='color:#D9001B;margin-left:20px;font-size:14px;'
            >
              您是VIP会员，VIP剩余时间已抵扣
              <span
                style='font-size:14px;'
                v-text='deductPrice'
              ></span>
              元。
            </span>
          </p>
          <p class='tips'>
            会员服务为虚拟商品，购买后不支持退款。
          </p>
          <p>
            <button
              @click="toPay"
              class='goPay'
            >前去支付</button>
            <span
              v-text="msg"
              style='margin-left:5px;color:tomato;'
            ></span>
          </p>
        </div>
      </div>
    </div>
    <!-- <wechat ref='weChat'></wechat> -->
  </div>
</template>
<script>
import { showDate } from "@/utils/time";
import HeaderTag from "_c/tagTitle/headerTag"; //引入头部组件
// import wechat from "./wechat"; //引入头部组件
import { openVip } from "@/requests/user"; //用户信息修改
import { mapState, mapActions } from "vuex";
export default {
  name: "vipInfo",
  components: {
    HeaderTag,
    // wechat
  },
  data() {
    return {
      msg: "", //提示信息
      vipType: "",
      buyExpireDate: "/年/月/日",
      price: 0,
      duration: 1,
      active: 0,
      payWay: 1,
      vipProgram: 1,
      payac: 0,
      deductPrice: 0
    };
  },
  computed: {
    ...mapState({
      judgeVip: state => state.user.userInfo.judgeVip,
      vipStatus: state => state.user.userInfo.vipStatus,
      expireDate: state => state.user.userInfo.expireDate
    })
  },
  watch: {
    judgeVip() {
      if (this.vipStatus > 0) {
        switch (this.judgeVip) {
          case 0:
            this.vipType = "免费版";
            break;
          case 1:
            this.vipType = "免费版";
            break;
          case 2:
            this.vipType = "VIP";
            break;
          case 3:
            this.vipType = "SVIP";
            break;
          default:
            break;
        }
        this.buyExpireDate =
          String(Number(showDate('Y', this.expireDate)) + this.duration) + "年" + showDate('M', this.expireDate) + "月" + showDate('D', this.expireDate) + "日"
      } else {
        this.vipType = '免费版'
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getUser();
    });
  },
  methods: {
    ...mapActions(["user/actionSetUserInfo"]),
    // 获取用户信息
    async getUser() {
      if (window.location.href.split("state=").length > 1) {
        let val = window.location.href.split("state=")[1].split("&")[0];
        if (Number(val) == 1) {
          window.$Message.show({
            title: "支付结果",
            type: "success",
            msg:
              "支付成功！感谢你对维护大师的支持。",
            confirmFn: async () => {
              this.$router.push({
                path: this.$PAGE_API.home.children.VIPInfo.path
              })
              this["user/actionSetUserInfo"]();
              window.$Message.hide();
            }
          });
        } else {
          window.$Message.show({
            title: "支付结果",
            type: "error",
            msg:
              "支付失败。遇到了未知问题导致失败，请稍后重试。",
            confirmFn: async () => {
              window.$Message.hide();
            }
          });
        }
      }
      if (this.$store.state.user.userInfo.vipStatus > 0) {
        switch (this.$store.state.user.userInfo.judgeVip) {
          case 0:
            this.vipType = "免费版";
            break;
          case 1:
            this.vipType = "免费版";
            break;
          case 2:
            this.vipType = "VIP";
            break;
          case 3:
            this.vipType = "SVIP";
            break;
          default:
            break;
        }
        this.comTime(this.$store.state.user.userInfo.expireDate)
      } else {
        this.vipType = '免费版'
      }
      this.comDuration(399)
    },
    styleActive(val) {
      this.active = val;
      if (!val) {
        this.vipProgram = 1
        this.comDuration(399)
      } else {
        this.vipProgram = 2
        this.comDuration(1299)
      }
    },
    payActive(val) {
      this.payac = val;
      if (!val) {
        this.payWay = 1
      } else {
        this.payWay = 2
      }
    },
    comFun() {
      this.comTime(this.expireDate)
      if (this.vipProgram == 1) {
        this.comDuration(399)
      } else {
        this.comDuration(1299)
      }
    },
    comTime(val) {
      this.buyExpireDate =
        String(Number(showDate('Y', val)) + this.duration) + "年" + showDate('M', val) + "月" + showDate('D', val) + "日"
    },
    // getNewData(dateTemp, days) {  
    //     let dateTemp1 = dateTemp.split("-");  
    //     let nDate = new Date(dateTemp1[1] + '-' + dateTemp1[2] + '-' + dateTemp1[0]); //转换为MM-DD-YYYY格式    
    //     let millSeconds = Math.abs(nDate) + (days * 24 * 60 * 60 * 1000);  
    //     let rDate = new Date(millSeconds);  
    //     let year = rDate.getFullYear();  
    //     let month = rDate.getMonth() + 1;  
    //     if (month < 10) month = "0" + month;  
    //     let date = rDate.getDate();  
    //     if (date < 10) date = "0" + date;  
    //     return (year + "年" + month + "月" + date + "日");  
    // },
    comDuration(val) {
      this.price = parseInt(String(val * this.duration), 10).toFixed(2)
      if (this.judgeVip == 2 && this.active == 1) {
        const x = String(399 / 365 * this.vipStatus);
        this.deductPrice = x.indexOf(".") != -1 ? x.substring(0, x.indexOf(".") + 3) : x;
        this.price = parseInt(String(val * this.duration), 10).toFixed(2) - this.deductPrice
      }
    },
    cutBack() {
      if (this.duration > 1) {
        this.duration = this.duration - 1;
        this.comFun()
      } else {
        this.duration = 1;
        this.comFun()
      }
    },
    add() {
      this.duration = this.duration + 1;
      this.comFun()
    },
    // 信息修改提交
    async toPay() {
      let res = await openVip({
        vipType: this.vipProgram,
        duration: this.duration,
        payType: this.payWay
      });
      if (res.code == 200) {
        // 为跳转支付平台提供参数
        let redirect_href = this.$pay.getRedirectUrl(
          res.data,
          "维护大师",
          ''
        );
        // 跳转相关二维码支付页面
        for (let i = this.$pay.pay_ways.length - 1; i >= 0; i--) {
          if (res.data.paytype === this.$pay.pay_ways[i].id) {
            // 判断是否在iframe中显示
            if (this.$pay.pay_ways[i].iframeShow) {
              // 微信弹出框
              // let weChat = this.$refs.weChat;
              // weChat.init(
              //     '',
              //     redirect_href,
              //     res.data.orderNo
              // );
              window.open(redirect_href);
            } else {
              // window.location.href = redirect_href;
              window.open(redirect_href);
            }
            break;
          }
        }
      } else {
        window.$Message.show({
          title: "前去支付",
          type: "error",
          msg: res.msg,
          confirmFn: async () => {
            window.$Message.hide();
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "_style/msgbox/_comMsg.scss";

.header {
  padding-left: 30px;
  text-align: left;
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #d9dee4;
}
.form-body {
  overflow: hidden;
  margin-left: 50px;
  width: 90%;
  padding: 10px 0px 20px 0px;
  .form-left {
    float: left;
    width: 150px;
    text-align: right;
    font-size: 14px;
    color: rgb(161, 161, 161);
    line-height: 40px;
  }
  .form-right {
    float: left;
    padding-left: 15px;
    text-align: left;
    line-height: 40px;
    button.goPay {
      width: 100px;
      line-height: 30px;
      color: #fff;
      background-color: rgb(0, 153, 204);
    }
  }
}
.duration {
  margin-bottom: 20px;
  font-size: 12px;
  color: #515151;
  height: 30px;
  line-height: normal;
  button {
    width: 30px;
    height: 30px;
    border: 1px solid rgba(230, 230, 230, 1);
    text-align: center;
    background: rgba(247, 247, 247, 1);
    cursor: pointer;
  }
  button.num {
    width: 40px;
    border: none;
    border-top: 1px solid rgba(230, 230, 230, 1);
    border-bottom: 1px solid rgba(230, 230, 230, 1);
    background: none;
    cursor: inherit;
  }
}
.pay {
  overflow: hidden;
  ul > li {
    float: left;
    width: 100px;
    height: 30px;
    line-height: 30px;
    border: 1px solid rgba(230, 230, 230, 1);
    margin-right: 10px;
    font-size: 12px;
    color: #515151;
    cursor: pointer;
    img {
      width: 14px;
      height: 14px;
      margin: 0 3px 0 8px;
      position: relative;
      top: 3px;
    }
  }
  li.active {
    position: relative;
    border: 1px solid rgba(0, 153, 204, 1);
  }
  li.active:after {
    content: "";
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    top: 0;
    right: 0;
    background: url("../../assets/img/icon/u389.png") no-repeat;
  }
}
.Program {
  overflow: hidden;
  margin-bottom: 20px;
  ul > li {
    float: left;
    width: 200px;
    height: 100px;
    border: 1px solid rgba(230, 230, 230, 1);
    margin-right: 10px;
    cursor: pointer;
    div {
      line-height: normal;
      margin-left: 15px;
    }
    .type {
      font-size: 24px;
      margin: 10px 0 10px 15px;
    }
    .price {
      color: #0099cc;
      font-size: 14px;
      margin-bottom: 7px;
    }
    .sub {
      font-size: 12px;
      color: #a1a1a1;
    }
  }
  li.crown {
    border: none;
    width: 100px;
    a {
      color: tomato;
      margin-top: 66px;
    }
    img {
      width: 30px;
      position: relative;
      top: 5px;
    }
  }
  li.active {
    position: relative;
    border: 1px solid rgba(0, 153, 204, 1);
  }
  li.active:after {
    content: "";
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    top: 0;
    right: 0;
    background: url("../../assets/img/icon/u389.png") no-repeat;
  }
}
.tips {
  font-size: 12px;
  color: #a1a1a1;
}
.money span {
  font-size: 20px;
  color: #d9001b;
}
.buyExpireDate {
  font-size: 14px;
}
</style>
